
import { mapGetters } from 'vuex';

export default {
  name: 'TheMainHeader',
  computed: {
    ...mapGetters('menu', ['mainMenuItems', 'homeMenuItem']),
    menuItems() {
      return this.mainMenuItems;
    },
    homeMenuPath() {
      return this.homeMenuItem.path;
    }
  }
};
